import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  templates: [],
  templateSaved: "false",
};

/**
 * @memberOf module:ManageJob
 * @namespace store
 * @description central store for manage job module
 */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
